import { Content, isFilled } from "@prismicio/client"
import { SliceComponentProps } from "@prismicio/react"
import useDocumentsFiles from "@airplan/hooks/document-files"
import Section from "@aura-design/system/section"
import Grid from "@aura-design/system/grid"
import Button from "@aura-design/system/button"
import { DownloadIcon } from "@radix-ui/react-icons"
import Skeleton from "@aura-design/system/dist/components/skeleton"
import Tabs from "@aura-design/system/tabs"

/**
 * Props for `DynamicDocuments`.
 */
export type DynamicDocumentsProps =
  SliceComponentProps<Content.DynamicDocumentsSlice>

/**
 * Component for "DynamicDocuments" Slices.
 */
const DynamicDocuments = ({ slice }: DynamicDocumentsProps): JSX.Element => {
  const files = useDocumentsFiles({ tags: slice.primary.tags?.split(";") })

  const filesByGroupTag = files.data?.results?.reduce(
    (acc, file) => {
      const groupTag = slice.primary.group_tags
        ?.split(";")
        .find((tag) => file.tags.includes(tag))
      if (groupTag) {
        if (!acc[groupTag]) {
          acc[groupTag] = []
        }
        acc[groupTag].push(file)
      }
      return acc
    },
    {} as Record<string, (typeof files.data.results)[0][]>,
  )

  return (
    <Section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {files.isLoading ? (
        <>
          <Grid col="one">
            {Array.from({ length: 2 }).map((_, i) => (
              <Skeleton className="fluid" heightAspectRation={5} key={i} />
            ))}
          </Grid>
        </>
      ) : files.isError ? (
        <></>
      ) : files.data.results.length === 0 ? (
        <></>
      ) : (
        <>
          <div>
            <Tabs
              data={Object.keys(filesByGroupTag).map((key) => {
                return { label: key, mode: "menu" }
              })}
              className="tabs-tags"
            >
              {Object.keys(filesByGroupTag).map((key) => {
                const groupByYear = filesByGroupTag[key].reduce(
                  (acc, file) => {
                    const year = file.data.year
                    if (!acc[year]) {
                      acc[year] = []
                    }
                    acc[year].push(file)
                    return acc
                  },
                  {} as Record<string, (typeof files.data.results)[0][]>,
                )

                return (
                  <div key={key} className="mt-1">
                    <Tabs
                      data={Object.keys(groupByYear).map((sub_key) => {
                        return { label: sub_key, mode: "menu" }
                      }).reverse()}
                      className="tabs-years"
                    >
                      {Object.keys(groupByYear)?.length > 0 &&
                        Object.keys(groupByYear).reverse().map((sub_key) => {
                          return (
                            <div key={sub_key}>
                              <Grid col="three">
                                {groupByYear[sub_key].map((item, index) => {
                                  return (
                                    <div
                                      key={`${slice.id}_${key}_${sub_key}_${index}`}
                                      
                                    >
                                      <Grid col="twelve" className="border border-solid border-y-dark-blue border-x-0 border-t-0 py-2">
                                        <div className="span-9 valign">
                                          <span>{item.data.title}</span>
                                        </div>
                                        <div className="span-3">
                                          <Button
                                            className="circle h-4 w-4 relative text-dark-yellow"
                                            href={`/api/files/syncfiledocs?name=${item.data.filename}`}
                                          >
                                            <DownloadIcon className="action icon h5" />
                                          </Button>
                                        </div>
                                      </Grid>
                                    </div>
                                  )
                                })}
                              </Grid>
                            </div>
                          )
                        })}
                    </Tabs>
                  </div>
                )
              })}
            </Tabs>
          </div>
        </>
      )}
    </Section>
  )
}

export default DynamicDocuments
